const { Number } = require('../../Number/Number')

const { isValid } = require('./isValid')

/**
 * @typedef {Object} ISemver
 * @property {number} major - Főverzió.
 * @property {number} minor - Alverzió.
 * @property {number} patch - Javítás.
 */

/**
 * Megadott paramétert megpróbálja semver részekre szétszedni.
 * @param {any} semver - A paraméter.
 * @returns {ISemver} A semver paraméterek.
 */
module.exports.getParts = function getParts (semver) {
  /** @type {ISemver} */
  const s = {
    major: 0,
    minor: 0,
    patch: 0
  }

  if (!isValid(semver)) {
    return s
  }

  const parts = (/** @type {string} */ (semver)).split('.')

  s.major = Number.parseInt(parts[0])
  s.minor = Number.parseInt(parts[1])
  s.patch = Number.parseInt(parts[2])

  return s
}
